import classnames from 'classnames'
import React, { useCallback, useEffect, useRef, useState } from 'react'
import { rectBottom } from '../../helpers/viewport'
import { useViewport } from '../../hooks'


const styles = {

  rootClass: 'c-button-with-menu',
  rootUpwardClass: 'c-button-with-menu--upward',
  rootOpenClass: 'c-button-with-menu--open',
  buttonClass: 'c-button-with-menu__button',
  menuClass: 'c-button-with-menu__menu',
  menuAlignRightClass: 'c-button-with-menu__menu--align-right'
}

const {
  rootClass: CLASSNAME_ROOT,
  rootUpwardClass: CLASSNAME_ROOT_UPWARD,
  rootOpenClass: CLASSNAME_ROOT_OPEN,
  buttonClass: CLASSNAME_BUTTON,
  menuClass: CLASSNAME_MENU,
  menuAlignRightClass: CLASSNAME_MENU__ALIGN_RIGHT,
  arrowUpClass: CLASSNAME_ARROW_UP,
  arrowDownClass: CLASSNAME_ARROW_DOWN
} = styles

export const makeButtonWithMenu = (ButtonComponent, MenuComponent) => ({
  className,
  'data-mu-test': dataAttributeTest,
  direction,
  showArrow,
  menuAlign
}) => {
  const element = useRef(null)

  const [open, setOpen] = useState(false)

  const [viewport] = useViewport({
    scroll: (e, viewport) => {
      windowHeight.current = viewport.windowHeight
    },
    resize: (e, viewport) => {
      windowHeight.current = viewport.windowHeight
    }
  })
  const windowHeight = useRef(viewport.windowHeight)

  const [elMenuBottom, setElMenuBottom] = useState(0)

  const elementMenu = useCallback(node => {
    if (node !== null) {
      setElMenuBottom(rectBottom(node.getBoundingClientRect()))
    }
  }, [])

  const { current: handleClickOutside } = useRef(e => {
    if (element.current && !element.current.contains(e.target)) {
      setOpen(false)
    }
  })

  useEffect(() => {
    document.addEventListener('click', handleClickOutside, { capture: true })
    const clear = () => {
      document.removeEventListener('click', handleClickOutside, {
        capture: true
      })
    }
    return clear
  }, [])

  const toggle = () => {
    setOpen(prev => !prev)
  }

  const _direction =
    (direction !== 'down' && elMenuBottom + 20 >= windowHeight.current) ||
      direction === 'up'
      ? 'up'
      : 'down'

  return (
    <div
      className={classnames(CLASSNAME_ROOT, className, {
        [CLASSNAME_ROOT_OPEN]: open,
        [CLASSNAME_ROOT_UPWARD]: _direction === 'up'
      })}
      onClick={toggle}
      ref={element}
      data-mu-test={dataAttributeTest}
    >
      <div className={CLASSNAME_BUTTON}>
        <ButtonComponent className='c-button-with-menu__button' />
      </div>
      <div
        className={classnames(CLASSNAME_MENU, {
          [CLASSNAME_MENU__ALIGN_RIGHT]: menuAlign === 'right'
        })}
        ref={elementMenu}
      >
        <MenuComponent
          className='c-button-with-menu__menu'
          showArrow={showArrow}
          direction={_direction}
          open={open}
        />
      </div>
    </div>
  )
}
